<template>
  <div>
    <div class="widewrapper main">
        <div class="container">
            <div class="row">
                <div class="col-md-8 blog-main info markdown-body">
                    <h2>Search result for: <mark v-html="search"></mark></h2>
                    <div v-for="(item, i) in result" :key="i" @click="goto(item.ID)">
                      <blockquote>
                        <h3>
                          {{item.Title}} / {{item.Score}}
                        </h3>
                      </blockquote>
                      <p v-html=item.Hit></p>
                      <hr>
                    </div>
                </div>
                <aside class="col-md-4 blog-aside">
                    <navi></navi>
                </aside>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
import navi from "../components/navi"
export default {
  name: 'Search',
  data () {
    return {
      search: '',
      result: [],
    }
  },
  metaInfo: {
      meta: [
          { name: 'keywords', content: '范祯的博客' },
          { name: 'description', content: '前360资深研发，分享些有趣好玩的东西' }
      ]
  },
  components: {
      navi,
  },
  mounted : function(){
    // 获取数据
    var item = this.$route.query.item;
    if (item == undefined) {
      this.$router.push({
          name: 'List',
          params: {}
      })
    }
    this.search = item
    this.getData(item)
  },
  methods : {
    getData: function (search) {
      var that = this
      let params = {
          search : search,
      }
      this.$api.searchBlog(params).then((res)=>{
          that.result = res.data
          document.title = that.search + "@Zane Fan's Blog";
      }).catch((res)=>{
      })
    },
    goto: function (id){
        this.$router.push({
            name: 'Info',
            query: {
                id : id
            }
        })
    },
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/Search.vue